import React from 'react';
import { replace } from 'react-router-redux';

import {ROUTE_CLUB, ROUTE_STATIONS} from '../../../constants/routeconstants';
import { connect } from 'react-redux';
import UserRoles from "../../../../../common/src/enums/UserRoles";
import {Link} from "react-router";
import * as AdminActions from "../../../actions/admin";
import {confirm} from "../../../utils/confirmDialog";
import {NotificationManager} from "react-notifications";
import UserFieldDataType from "../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from "../../reusable/UserFieldElement";
import moment from "moment";
import config from "../../../../../server/src/config";
import {nullToBlank} from "../../../../../common/src/util/lib";

class StationsPage extends React.Component {

    static getId() {
        return ROUTE_STATIONS;
    }

    static getAllowedRoles() {
        return [UserRoles.MAIN_ADMIN, UserRoles.CLUB_ADMIN, UserRoles.SECTION_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            editId: null,
            filter: '',
            sort: 'Stationsnr',
        };
    }

    componentDidMount() {
        this.props.dispatch(AdminActions.getListItems('station'));
    }

    fields = [];
    render() {
        return this.props.stations ? <div>
            <div className="sub-page-title">
                <h2>Stationer</h2>
            </div>
            <div id="sub-page-content" className="sub-page-content">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th scope="row" className={this.state.editId === null ? "clickable" : ""} onClick={() => {if (this.state.editId === null) this.setState({sort: 'Stationsnr'})}}>Nr</th>
                            <th className={this.state.editId === null ? "clickable" : ""} onClick={() => {if (this.state.editId === null) this.setState({sort: 'Navn'})}}>Navn</th>
                            <th>L-grader</th>
                            <th>L-min</th>
                            <th>L-sek</th>
                            <th>L-sek/100</th>
                            <th>L-min/1000</th>
                            <th>B-grader</th>
                            <th>B-min</th>
                            <th>B-sek</th>
                            <th>B-sek/100</th>
                            <th>B-min/1000</th>
                            <th className="commands-column"></th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.props.stations
                        .filter(s => this.state.filter === '' ? true :
                            nullToBlank(s.Stationsnr).toUpperCase().search(this.state.filter) >= 0 ||
                            nullToBlank(s.Navn).toUpperCase().search(this.state.filter) >= 0
                        )
                        .sort((s1, s2) => {
                            if (s1.Stationsnr === '') return 1;
                            if (s2.Stationsnr === '') return -1;
                            const comp = (s1[this.state.sort] === null ? '' : s1[this.state.sort].trim()).localeCompare(s2[this.state.sort] === null ? '' : s2[this.state.sort].trim(), 'da-DK');
                            return comp === 0 ? (s1.Stationsnr < s2.Stationsnr ? -1 : s1.Stationsnr > s2.Stationsnr ? 1 : 0) : comp;
                        })
                        .toArray().concat(this.state.editId === 'new' ? [this.state] : []).map(station => {
                            return this.state.editId === null || (station.Stationsnr !== this.state.editId && typeof(station.editId) === 'undefined') ? <tr key={station.Stationsnr} id={'row-' + station.Stationsnr}>
                                <th scope="row">{station.Stationsnr}</th>
                                <td>{station.Navn}</td>
                                <td>{station.Laengde_grader}</td>
                                <td>{station.Laengde_min}</td>
                                <td>{station.Laengde_sek}</td>
                                <td>{station.Laengde_100_dele_sek}</td>
                                <td>{station.Laengde_1000_dele_min}</td>
                                <td>{station.Bredde_grader}</td>
                                <td>{station.Bredde_min}</td>
                                <td>{station.Bredde_sek}</td>
                                <td>{station.Bredde_100_dele_sek}</td>
                                <td>{station.Bredde_1000_dele_min}</td>
                                <td className="commands-column">
                                    <i className={"fa fa-pencil " + (this.state.editId === null && this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? 'clickable' : 'disabled')} title="Rediger station" onClick={() => {
                                        if (this.state.editId === null && this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id) this.setState({
                                            editId: station.Stationsnr,
                                            Stationsnr: station.Stationsnr,
                                            Navn: station.Navn === null ? '' : station.Navn,
                                            Laengde_grader: station.Laengde_grader === null ? '' : String(station.Laengde_grader),
                                            Laengde_min: station.Laengde_min === null ? '' : String(station.Laengde_min),
                                            Laengde_sek: station.Laengde_sek === null ? '' : String(station.Laengde_sek),
                                            Laengde_100_dele_sek: station.Laengde_100_dele_sek === null ? '' : String(station.Laengde_100_dele_sek),
                                            Laengde_1000_dele_min: station.Laengde_1000_dele_min === null ? '' : String(station.Laengde_1000_dele_min),
                                            Bredde_grader: station.Bredde_grader === null ? '' : String(station.Bredde_grader),
                                            Bredde_min: station.Bredde_min === null ? '' : String(station.Bredde_min),
                                            Bredde_sek: station.Bredde_sek === null ? '' : String(station.Bredde_sek),
                                            Bredde_100_dele_sek: station.Bredde_100_dele_sek === null ? '' : String(station.Bredde_100_dele_sek),
                                            Bredde_1000_dele_min: station.Bredde_1000_dele_min === null ? '' : String(station.Bredde_1000_dele_min),
                                        });
                                    }}/>
                                    <i className={"fa fa-trash " + (this.state.editId === null && this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? 'clickable' : 'disabled')} title="Slet station" onClick={() => {
                                        if (this.state.editId === null && this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id) confirm("Slet", <span>Ønsker du at slette station <b>{station.Stationsnr} ({station.Navn})</b>?</span>, () => {
                                            this.props.dispatch(AdminActions.deleteListItem('station', station.Stationsnr, () => {
                                                NotificationManager.success("Station " + station.Stationsnr + " (" + station.Navn + ") er slettet.", "Sletning", 4000);
                                            }));
                                        });
                                    }}/>
                                </td>
                            </tr> : <tr key="editor" id="row-editor" className="edit-row">
                                <th>
                                    <UserFieldElement dataType={UserFieldDataType.regex} placeholder="" className="field50" containerClassName="display-inline-block"
                                                      name="Stationsnr" id="Stationsnr" maxLength="3" options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]} value={this.state.Stationsnr}
                                                      autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      //errorWidth="auto" errorStyle={{container: {minHeight: 40, marginLeft:'-130px', zIndex: 99999}}}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[0] = instance; }}
                                    />
                                </th>
                                <td>
                                    <UserFieldElement dataType={UserFieldDataType.string} placeholder="" className="" containerClassName=""
                                                      name="Navn" id="Navn" maxLength="25" value={this.state.Navn}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[1] = instance; }}
                                    />
                                </td>
                                <td>
                                    <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                                      name="Laengde_grader" id="Laengde_grader" maxLength="3" value={this.state.Laengde_grader}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[2] = instance; }}
                                    />
                                </td>
                                <td>
                                    <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                                      name="Laengde_min" id="Laengde_min" maxLength="3" value={this.state.Laengde_min}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[3] = instance; }}
                                    />
                                </td>
                                <td>
                                    <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                                      name="Laengde_sek" id="Laengde_sek" maxLength="3" value={this.state.Laengde_sek}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[4] = instance; }}
                                    />
                                </td>
                                <td>
                                    <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                                      name="Laengde_100_dele_sek" id="Laengde_100_dele_sek" maxLength="3" value={this.state.Laengde_100_dele_sek}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[5] = instance; }}
                                    />
                                </td>
                                <td>
                                    <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                                      name="Laengde_1000_dele_min" id="Laengde_1000_dele_min" maxLength="3" value={this.state.Laengde_1000_dele_min}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[6] = instance; }}
                                    />
                                </td>
                                <td>
                                    <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                                      name="Bredde_grader" id="Bredde_grader" maxLength="3" value={this.state.Bredde_grader}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[7] = instance; }}
                                    />
                                </td>
                                <td>
                                    <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                                      name="Bredde_min" id="Bredde_min" maxLength="3" value={this.state.Bredde_min}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[8] = instance; }}
                                    />
                                </td>
                                <td>
                                    <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                                      name="Bredde_sek" id="Bredde_sek" maxLength="3" value={this.state.Bredde_sek}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[9] = instance; }}
                                    />
                                </td>
                                <td>
                                    <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                                      name="Bredde_100_dele_sek" id="Bredde_100_dele_sek" maxLength="3" value={this.state.Bredde_100_dele_sek}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[10] = instance; }}
                                    />
                                </td>
                                <td>
                                    <UserFieldElement dataType={UserFieldDataType.int} placeholder="" className="field50" containerClassName="display-inline-block"
                                                      name="Bredde_1000_dele_min" id="Bredde_1000_dele_min" maxLength="3" value={this.state.Bredde_1000_dele_min}
                                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                      onChange={this.onStandardFieldChange}
                                                      ref={instance => { this.fields[11] = instance; }}
                                    />
                                </td>
                                <td className="commands-column">
                                    <i className="fa fa-save clickable" title="Gem station" onClick={() => {
                                        this.save();
                                    }}/>
                                    <i className="fa fa-undo clickable" title="Annuller" onClick={() => {
                                        this.setState({editId: null});
                                    }}/>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
            <div className="sub-page-actions">
                <button className={"btn-primary" + (this.state.editId === null && this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? '' : ' disabled')} title="Opret ny station" onClick = {() => {
                    if (this.state.editId === null && this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id) {
                        this.setState({
                            editId: 'new',
                            Stationsnr: '',
                            Navn: '',
                            Laengde_grader: '',
                            Laengde_min: '',
                            Laengde_sek: '',
                            Laengde_100_dele_sek: '',
                            Laengde_1000_dele_min: '',
                            Bredde_grader: '',
                            Bredde_min: '',
                            Bredde_sek: '',
                            Bredde_100_dele_sek: '',
                            Bredde_1000_dele_min: '',
                        });
                        setTimeout(function () {
                            const content = document.getElementById("sub-page-content");
                            content.scrollTop = content.scrollHeight;
                        });
                    }
                }}>Ny</button>
                <label htmlFor="filter" className={this.state.editId === null ? "" : "disabled"}>Filter</label>
                <UserFieldElement dataType={UserFieldDataType.string} placeholder="Indtast søgeværdi" className="field-1 large-field"
                                  name="filter" id="filter" disabled={this.state.editId !== null}
                                  autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                  onChange={(e) => {
                                      const val = e.target.value.toUpperCase();
                                      //this.onStandardFieldChange(e);
                                      if (this.timeoutHandler !== null) clearTimeout(this.timeoutHandler);
                                      this.timeoutHandler = setTimeout(() => {
                                          this.setState({filter: val});
                                      }, 500);
                                  }}
                />
                <label htmlFor="sort" className={this.state.editId === null ? "" : "disabled"}>Sortering</label>
                <UserFieldElement dataType={UserFieldDataType.enum} placeholder="false" className="field-1 large-field"
                                  name="sort" id="sort"  disabled={this.state.editId !== null} value={this.state.sort} options={[
                                    {key: 'Stationsnr', value: 'Stationsnr'},
                                    {key: 'Navn', value: 'Navn'},
                                  ]}
                                  autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                  onChange={this.onStandardFieldChange}
                />
            </div>
        </div> : null;
    }

    timeoutHandler = null;

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    save = () => {
        if (this.allInputValid()) {
            const stationsNr = this.state.Stationsnr;
            const entity = {
                Stationsnr: this.state.Stationsnr,
                Navn: this.state.Navn === '' ? null : this.state.Navn,
                Laengde_grader: this.state.Laengde_grader === '' ? null : Number(this.state.Laengde_grader),
                Laengde_min: this.state.Laengde_min === '' ? null : Number(this.state.Laengde_min),
                Laengde_sek: this.state.Laengde_sek === '' ? null : Number(this.state.Laengde_sek),
                Laengde_100_dele_sek: this.state.Laengde_100_dele_sek === '' ? null : Number(this.state.Laengde_100_dele_sek),
                Laengde_1000_dele_min: this.state.Laengde_1000_dele_min === '' ? null : Number(this.state.Laengde_1000_dele_min),
                Bredde_grader: this.state.Bredde_grader === '' ? null : Number(this.state.Bredde_grader),
                Bredde_min: this.state.Bredde_min === '' ? null : Number(this.state.Bredde_min),
                Bredde_sek: this.state.Bredde_sek === '' ? null : Number(this.state.Bredde_sek),
                Bredde_100_dele_sek: this.state.Bredde_100_dele_sek === '' ? null : Number(this.state.Bredde_100_dele_sek),
                Bredde_1000_dele_min: this.state.Bredde_1000_dele_min === '' ? null : Number(this.state.Bredde_1000_dele_min),
            };
            if (this.state.editId === 'new') this.props.dispatch(AdminActions.createListItemItem('station', entity, id => {
                NotificationManager.success("Station " + id + " (" + this.state.Navn + ") er oprettet.", "Oprettelse", 4000);
                this.setState({editId: null});
                setTimeout(function () {
                    const currentRow = document.getElementById("row-" + stationsNr);
                    currentRow.scrollIntoView(false);
                });
            }));
            else this.props.dispatch(AdminActions.updateListItem('station', this.state.editId, entity, id => {
                NotificationManager.success("Station " + id + " (" + this.state.Navn + ") er opdateret.", "Opdatering", 4000);
                this.setState({editId: null});
                setTimeout(function () {
                    const currentRow = document.getElementById("row-" + stationsNr);
                    currentRow.scrollIntoView(false);
                });
            }));
        }  else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
    },
    stations: state.admin.stations,
});

export default connect(mapStateToProps)(StationsPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/lists/StationsPage.js